const config = {
    title: 'MTLX.Ordinals',
    description: 'Metallic Ordinals 111 collection',
    contractAddress: '0x4c0B34baC77bfB4afDB3d467CAF88E2e05a5887a', // ETH LIVE
    maxMintperWallet: 2,
    price: 0.04,
    INFURA_ID: '6792f392fbd8479a97d4e99da39e515a'
    }
    
    export { config }